import axios from "axios";
import { API_URL } from "../client-config";

// Centralized Axios instance for the app.
// Automatically attaches auth token and provides a single place
// to tweak cross-cutting concerns (timeouts, logging, etc.).
export const Api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

// Attach Authorization header (if token exists) to every request
Api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");

    if (token) {
      config.headers = config.headers || {};

      // Do not override an explicitly set Authorization header
      if (!config.headers["Authorization"]) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Simple response interceptor – keeps behavior consistent
Api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle unauthorized globally
    if (error.response && error.response.status === 401) {
      // Clear any stored auth state
      sessionStorage.clear();

      // Avoid infinite redirect loops
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }

    return Promise.reject(error);
  }
);